<template>
  <div class="container-view">
    <Breadcrumbs />
    <div class="row col-12">
      <div class="col-6">
        <q-card class="firstCard">
          <q-card-section>
            <div class="col-10 info-box">
            <div style="margin-right: 6px">
              <q-img
                :src="require('@/assets/img/info-24px.svg')"
                width="24px"
                height="24px"
              />
            </div>
            <div class="txt-info">
              RELACIÓN DE USUARIOS AUTORIZADOS EN APLICACIONES
            </div>
          </div>
            <q-btn
            data-cy="download-csv-users-aplications"
            @click="downloadCSV(controllerUsuarioApp)"
            unelevated
            color="primary"
            :icon="'img:' + require('@/assets/img/file_download_white_24dp.svg')"
            >Exportar</q-btn>
          </q-card-section>
        </q-card>
      </div>
      <div class="col-6">
        <q-card>
          <q-card-section>
            <div class="col-10 info-box">
            <div style="margin-right: 6px">
              <q-img
                :src="require('@/assets/img/info-24px.svg')"
                width="24px"
                height="24px"
              />
            </div>
            <div class="txt-info">
              RELACIÓN DE AMBITOS Y APLICACIONES
            </div>
          </div>
            <q-btn
            data-cy="download-csv-ambitos-aplications"
            @click="downloadCSV(controlllerAmbitosApp)"
            unelevated
            color="primary"
            :icon="'img:' + require('@/assets/img/file_download_white_24dp.svg')"
            >Exportar</q-btn>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </div>
</template>
<script>
import Message from '@/components/shared/mixins/Message.js';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';
import Loading from '@/components/shared/mixins/Loading.js';
import { QImg } from 'quasar';
import Utils from '@/components/shared/helpers/Utils.js';

export default {
  components: {
    Breadcrumbs,
    QImg
  },
  mixins: [Message, Loading],
  data: function () {
    return {
      controllerUsuarioApp: '/CSV/AplicacionesUser',
      controlllerAmbitosApp: '/CSV/AmbitosAplicaciones'
    };
  },
  methods: {
    downloadCSV (controllerText) {
      this.showLoading();
      let request = {
        controller: controllerText,
        filter: {}
      };

      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('PF/getSuitBlob', request)
          .then(response => {
            let disposition = response.request.getResponseHeader('Content-Disposition');
            let filename = Utils.getFileNameFromHeader(disposition);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            link.click();
            resolve(url);
            this.hideLoading();
          })
          .catch(err => {
            this.hideLoading();
            this.showError('No hay datos para exportar, consulte con el administrador.');
            reject(err);
          });
      });
    }
  }
};
</script>
<style scoped lang="scss">
.info-box {
    display: flex;
    align-items: center;
    margin-bottom: 35px;
    .txt-info {
      font-family: "DINPro";
      font-size: 10px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.6;
      letter-spacing: 1.5px;
      color: rgba(0, 0, 0, 0.87);
    }
  }

  :deep() {
    .q-icon {
      margin-right: 10px !important;
    }
  }
  .firstCard{
    margin-right: 25px;
  }
</style>
